<template>
  <section
    class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-900 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Pilih Item Mix</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <div class="pt-5">
          <SearchBox v-model="searchMenu" placeholder="Cari Menu" class-add="w-full" />
          <LocalFilterLane :items="allItemCategories" class-add="my-3" @setCurrentItem="setCurrentFilterCategory" />
          <div
            class="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 max-h-[calc(100dvh-290px)] overflow-y-auto pb-24">
            <ProductCard v-for="item in filteredItems" :key="item.id" :btnAddItem="'add-item-' + item.id"
              :productName="item.name" :product="item" :productPrice="formatRupiah(item.price)" :image="item.image"
              @add-order="addMixItem" :isClose="!item.details" />
          </div>
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-bold text-gray-500 dark:text-gray-300">Daftar Item Dipilih</h3>
            <span class="text-xs text-gray-500 dark:text-gray-400">
              Maksimal {{ itemMix.mix_qty_per_unit }} item dapat dipilih
            </span>
          </div>
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Product Mix</TableHeadCell>
                    <TableHeadCell>Qty</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="itemMix.selected_product_mix.length == 0">
                    <TableCell colspan="6" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(item, index) in itemMix.selected_product_mix" :key="item.id" :index="index"
                    alternateRow isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ item.name }}</TableCell>
                    <TableCell>
                      <div class="flex items-center rounded-lg p-1">
                        <button @click="reduceMixItem(item)"
                          class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <MinusCircleIcon class="h-5 w-5" />
                        </button>
                        <InputTextCustom v-model="item.quantity" id="item-min-qty-per-unit" type="number" min="1"
                          :max="itemMix.mix_qty_per_unit" @input="inputMixItem(item)" />
                        <button @click="addMixItem(item)"
                          class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <PlusCircleIcon class="h-5 w-5" />
                        </button>
                      </div>
                    </TableCell>
                    <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <button :id="'delete-data-' + item.id" @click="deleteItemMix(item)"
                        class="bg-danger hover:bg-hover-danger flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 text-white group-hover:text-light-50" />
                      </button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
            @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit"
            button_class="mx-1 bg-primary hover:bg-hover-primary text-white" @click="submitMixItem" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import SubmitButton from '../form/SubmitButton.vue';
  import { formatRupiah } from '@/helpers/formatRupiah';
  import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
  import LocalFilterLane from '@/views/pages/new-transaction/order/LocalFilterLane.vue';
  import ProductCard from '@/views/pages/new-transaction/order/ProductCard.vue';
  import { TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell } from '@/components/table';
  import { TrashIcon, MinusCircleIcon, PlusCircleIcon } from '@heroicons/vue/24/solid';
  import InputTextCustom from '../form/InputTextCustom.vue';

  export default {
    name: "ModalMixItem",
    props: {
      product: {
        type: Object,
        default: null,
      },
      allItemCategories: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SubmitButton, SearchBox, LocalFilterLane, ProductCard, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, TrashIcon, InputTextCustom, MinusCircleIcon, PlusCircleIcon
    },
    data() {
      return {
        showModal: true,
        itemMix: {
          id: this.product.selected_product_mix ? this.product.id : null,
          item_id: this.product.selected_product_mix ? this.product.item_id : this.product.id,
          name: this.product.name,
          quantity: 1,
          price: this.product.selected_product_mix ? this.product.price : this.product.sale_price,
          discount_price: this.product.selected_product_mix ? this.product.discount_price : this.product.discount_price,
          service_charge_applied: this.product.selected_product_mix ? this.product.service_charge_applied : this.product.service_charge_applied,
          tax_applied: this.product.selected_product_mix ? this.product.tax_applied : this.product.tax_applied,
          discount_applied: this.product.selected_product_mix ? this.product.discount_applied : this.product.discount_applied,
          product_mix: this.product.selected_product_mix ? this.product.product_mix : this.product.product_mix,
          has_product_mix: this.product.selected_product_mix ? this.product.has_product_mix : this.product.has_product_mix,
          selected_product_mix: this.product.selected_product_mix || [],
          mix_qty_per_unit: this.product.selected_product_mix ? this.product.mix_qty_per_unit : this.product.mix_qty_per_unit,
        },
        selectedCategory: null,
        isEdit: !!this.product,
        searchMenu: ''
      }
    },
    watch: {
      product(newVal) {
        if (newVal) {
          this.itemMix.item_id = newVal.id;
          this.itemMix.name = newVal.name;
          this.itemMix.quantity = 1;
          this.itemMix.price = newVal.sale_price;
          this.itemMix.discount_price = newVal.discount_price;
          this.itemMix.total = parseFloat(newVal.sale_price - newVal.discount_price) * 1;
          this.itemMix.service_charge_applied = newVal.service_charge_applied;
          this.itemMix.tax_applied = newVal.tax_applied;
          this.itemMix.discount_applied = newVal.discount_applied;
          this.itemMix.has_product_mix = newVal.has_product_mix;
          this.itemMix.product_mix = newVal.product_mix;
          this.itemMix.outlet_id = newVal.outlet_id;
          this.itemMix.selected_product_mix = newVal.selected_product_mix;
          this.itemMix.mix_qty_per_unit = newVal.mix_qty_per_unit;
          this.isEdit = true;
        } else {
          this.itemMix.item_id = null;
          this.itemMix.name = '';
          this.itemMix.quantity = 1;
          this.itemMix.price = 0;
          this.itemMix.discount_price = 0;
          this.itemMix.total = 0;
          this.itemMix.service_charge_applied = false;
          this.itemMix.tax_applied = false;
          this.itemMix.discount_applied = false;
          this.itemMix.has_product_mix = false;
          this.itemMix.product_mix = [];
          this.itemMix.outlet_id = null;
          this.itemMix.selected_product_mix = newVal.selected_product_mix;
          this.itemMix.mix_qty_per_unit = null;
          this.isEdit = false;
        }
      },
    },
    computed: {
      filteredItems() {
        let result = [...this.product.product_mix];

        // Map and add image URL
        result = result.map((item) => {
          item.image = item.details && item.details.image_url ? `${process.env.VUE_APP_WEBSOCKET_URL}/file/${item.details.image_url}` : null;
          return item;
        });

        // Filter out items without category
        result = result.filter((item) => item.itemCategory !== undefined);

        // Apply search filter if any
        if (this.searchMenu) {
          result = result.filter(
            (item) => item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
          );
        }

        // Apply category filter if selected
        if (this.selectedCategory) {
          result = result.filter(
            (item) => item.category_id === this.selectedCategory
          );
        }

        // Sort: items with details first, then items without details
        result.sort((a, b) => {
          const aHasDetails = a.details ? 1 : 0;
          const bHasDetails = b.details ? 1 : 0;
          return bHasDetails - aHasDetails; // Descending: 1 (has details) comes before 0 (no details)
        });

        return result;
      },
    },
    methods: {
      formatRupiah,
      setCurrentFilterCategory(item) {
        this.selectedCategory = item;
      },
      isSelectedItemMix(item) {
        return this.itemMix.selected_product_mix.some(mix => mix.id === item.id);
      },
      deleteItemMix(item) {
        this.itemMix.selected_product_mix = this.itemMix.selected_product_mix.filter(mix => mix.id !== item.id);
      },
      addMixItem(product) {
        const isExist = this.itemMix.selected_product_mix.find(mix => mix.id === product.id);

        if (this.itemMix.mix_qty_per_unit < (this.itemMix.selected_product_mix.reduce((total, mix) => total + Number(mix.quantity), 0) + 1)) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Mix item sudah mencapai batas maksimum', life: 3000 });
          return;
        }
        if ((isExist?.quantity + 1) > product.max_qty) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: `${product.name} sudah mencapai batas maksimum`, life: 3000 });
          return;
        }
        if (isExist) {
          this.itemMix.selected_product_mix = this.itemMix.selected_product_mix.map((mix) => {
            if (mix.id === product.id) {
              mix.quantity = Number(mix.quantity) + 1;
            }
            return mix;
          });
        } else {
          product.quantity = 1;
          this.itemMix.selected_product_mix.push(product);
        }
      },
      reduceMixItem(product) {
        const isExist = this.itemMix.selected_product_mix.find(mix => mix.id === product.id);

        if (isExist) {
          this.itemMix.selected_product_mix = this.itemMix.selected_product_mix.map((mix) => {
            if (mix.id === product.id) {
              mix.quantity = mix.quantity > 1 ? Number(mix.quantity) - 1 : 1;
            }
            return mix;
          });
        }
      },
      inputMixItem(product) {
        const existingItem = this.itemMix.selected_product_mix.find(detail => detail.id === product.id);
        if (this.itemMix.mix_qty_per_unit < (this.itemMix.selected_product_mix.reduce((total, mix) => mix.id === product.id ? total : total + Number(mix.quantity), 0) + Number(existingItem.quantity))) {
          const totalMixExThisProduct = this.itemMix.selected_product_mix.reduce((total, mix) => mix.id === product.id ? total : total + Number(mix.quantity), 0);
          const lackQty = this.itemMix.mix_qty_per_unit - totalMixExThisProduct;
          existingItem.quantity = lackQty > product.max_qty ? product.max_qty : lackQty;
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Mix item sudah mencapai batas maksimum', life: 3000 });
        } else if (existingItem.quantity > product.max_qty) {
          existingItem.quantity = product.max_qty;
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Jumlah melebihi batas', life: 3000 });
        } else {
          existingItem.quantity = Number(existingItem.quantity) <= 0 ? 1 : existingItem.quantity;
        }
      },
      closeModal() {
        this.showModal = false;
        setTimeout(() => {
          this.$emit('closeModal');
        }, 200);
      },
      submitMixItem() {
        const totalMix = this.itemMix.selected_product_mix.reduce((total, mix) => total + mix.quantity, 0);
        console.log(totalMix, this.itemMix.mix_qty_per_unit);
        if (totalMix !== this.itemMix.mix_qty_per_unit) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Jumlah mix item tidak sesuai', life: 3000 });
          return;
        } else {
          this.$confirm.require({
            group: 'headless',
            header: 'Apakah anda yakin ingin menyimpan mix item?',
            message: 'Silahkan konfirmasi sebelum diproses.',
            acceptLabel: 'Ya',
            rejectLabel: 'Tidak',
            accept: () => {
              this.$emit('submitMixItem', this.itemMix);
            },
            reject: () => {
              this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan mix item', life: 3000 });
            }
          });
        }
      },
    }
  }
</script>
